import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AgFloatingFilterComponent } from 'ag-grid-angular';
import { IFloatingFilterParams } from 'ag-grid-community';
import { IntegrationService } from '../../../../shared/services/integration.service';
import { FormsModule } from '@angular/forms';
import { CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-instruction-status-filter',
    templateUrl: './instruction-status-filter.component.html',
    styleUrls: ['./instruction-status-filter.component.scss'],
    standalone: true,
    imports: [FormsModule, CdkOverlayOrigin, NgClass, CdkConnectedOverlay]
})
export class InstructionStatusFilterComponent implements OnInit, AgFloatingFilterComponent {
  @ViewChild('eInput', { read: ElementRef, static: true }) eInput: ElementRef;
  params: IFloatingFilterParams;
  currentValue: Number | null | string = null;
  selectedValue: Number | null | string = null;
  isOpen: boolean;
  instructionStatusOptions = ['Active', 'Restarted', 'Stopped'];
  public deleteIcon: string;
  isSelected: boolean;

  constructor(private integrationService: IntegrationService) {}
  ngOnInit(): void {
    const assetUrl = this.integrationService.getApplicationPath();
    this.deleteIcon = assetUrl + 'assets/images/Delete.svg';
  }

  agInit(params: IFloatingFilterParams): void {
    this.params = params;
  }

  openMenu(): void {
    this.isOpen = !this.isOpen;
    if (this.currentValue) {
      this.selectedValue = this.currentValue;
    }
  }

  toggleInstructionStatus(value: boolean): void {
    this.isOpen = value;
  }

  onParentModelChanged(parentModel: any): void {
    // When the filter is empty we will receive a null value here
    if (!parentModel) {
      this.currentValue = null;
    } else {
      this.currentValue = parentModel.filter;
    }
  }

  applyInstructionStatus(): void {
    if (!this.selectedValue) {
      // Remove the filter
      this.params.parentFilterInstance((instance: any) => {
        instance.onFloatingFilterChanged(null, null);
      });
      this.isOpen = false;
      return;
    }
    this.currentValue = this.selectedValue;
    this.params.parentFilterInstance((instance: any) => {
      instance.onFloatingFilterChanged('equals', this.currentValue);
      this.isSelected = true;
    });
    this.isOpen = false;
  }

  clearInstructionStatus(event): void {
    event.preventDefault();
    this.selectedValue = null;
    this.applyInstructionStatus();
  }
}
